<template>
  <vue-editor v-model="editor_content" @blur="onEditorBlur" :editor-toolbar="custom_toolbar" />
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { patchIslandVacationGroup } from '@/http'

export default {
  name: 'IslandVacationGroupsDetailItinerary',
  components: { VueEditor },
  props: {
    groupDetail: { Object }
  },
  data() {
    return {
      editor_content: '',
      custom_toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        ['clean']
      ]
    }
  },
  watch: {
    groupDetail: {
      handler(newValue) {
        this.editor_content = newValue.itinerary_description
      },
      immediate: true,
    }
  },
  methods: {
    onEditorBlur() {
      patchIslandVacationGroup(this.$route.params.id, { itinerary_description: this.editor_content })
        .then(() => {
          this.$emit('getGroupInfo')
          this.$notify({
            type: 'success',
            title: 'Itinerary saved',
          })
        })
    },
  }
}
</script>
